import { GeoEventFormStatus } from 'shared/types';

export const statusOptions: { label: string; value: GeoEventFormStatus }[] = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
];
